import { faPencil, faTimes } from "@fortawesome/pro-light-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useState, useEffect, useRef } from "react";
import { useDispatch } from "react-redux";
import { useTranslation } from "react-i18next";
import { Modal } from "../Form/Modal";
import classNames from "classnames";

export default function BorderContainer (props) {
    const { t } = useTranslation('common');
    const { showBorder, background_color, font_color, font_size, font_weight, allow_close, allow_edit, text, size, wizard, kasm, sharing } = props || {}
    const { top, left, right, bottom } = size || {}
    const [show, setShow] = useState(showBorder);
    const [hide, setHide] = useState(window.localStorage.getItem('border' + kasm?.kasm_id + 'closed') || false);
    const [open, setOpen] = useState(false);
    const [newText, setNewText] = useState(text);

    const [contentText, setContentText] = useState(text);

    const border = {
        top: hide ? 0 : top,
        right: hide ? 0 : right,
        bottom: hide ? 0 : bottom,
        left: hide ? 0 : left
    }

    useEffect(() => {
        let storedText = window.localStorage.getItem('border' + kasm?.kasm_id + 'text' )
        if (allow_edit && storedText) {
            setContentText(storedText)
            setNewText(storedText)
        }
    }, [])

    if (!show) {
        return <div className={classNames("tw-inset-0 tw-flex tw-border-solid tw-border-0 tw-z-[9999]", sharing ? 'tw-absolute' : 'tw-fixed')}>{props.children}</div>
    }

    const borderText = (style) => {
        let replaceText = text
        if (wizard !== true) {
            replaceText = contentText
            replaceText = replaceText.replaceAll('{user_id}', kasm.user_id || '')
            replaceText = replaceText.replaceAll('{username}', kasm.username || '')
            replaceText = replaceText.replaceAll('{image_name}', kasm.image.friendly_name || '')
            replaceText = replaceText.replaceAll('{kasm_id}', kasm.kasm_id || '')
            replaceText = replaceText.replaceAll('{image_id}', kasm.image.image_id || '')
            replaceText = replaceText.replaceAll('{egress_provider_name}', kasm?.egress_provider_name || '')
            replaceText = replaceText.replaceAll('{egress_gateway_name}', kasm?.egress_gateway_name || '')
            replaceText = replaceText.replaceAll('{egress_gateway_country}', kasm?.egress_gateway_country || '')
            replaceText = replaceText.replaceAll('{egress_gateway_city}', kasm?.egress_gateway_city || '')
            replaceText = replaceText.replaceAll('{zone_name}', kasm?.zone_name || '')
        }

        const editText = () => {
            setOpen(true)
        }
    
        return <div className="tw-absolute tw-left-0 tw-right-0 tw-flex tw-overflow-hidden tw-justify-center tw-items-center" style={style}>{allow_edit && wizard !== true ? <button type="button" className="tw-ml-2 tw-bg-transparent" onClick={editText}>{replaceText}</button> : <React.Fragment>{replaceText}</React.Fragment>}</div>
    }

    const handleSubmit = () => {
        if ('kasm_id' in kasm) {
            window.localStorage.setItem('border' + kasm.kasm_id + 'text', newText)
            setContentText(newText)
            setOpen(false)
        }
    }

    const reset = () => {
        if ('kasm_id' in kasm) {
            window.localStorage.removeItem('border' + kasm.kasm_id + 'text')
            setNewText(text)
        }
    }

    const closeClicked = () => {
        if (!wizard) {
            setHide(true)
            window.localStorage.setItem('border' + kasm.kasm_id + 'closed', true)
        } else {
            props.setDesign(false)
        }
    }
    
    return (      
        <div className={classNames("tw-fixed tw-inset-0 tw-flex tw-border-solid tw-border-0 tw-z-[9999]", sharing ? 'tw-absolute' : 'tw-fixed')} 
        style={{ 
            borderTopWidth: border.top + 'px', 
            borderBottomWidth: border.bottom + 'px',
            borderLeftWidth: border.left + 'px',
            borderRightWidth: border.right + 'px',
            borderColor: background_color
        }}>
            {top > 0 && text && borderText({ top: '-' + border.top + 'px', height: border.top + 'px', color: font_color, fontWeight: font_weight, fontSize: font_size + 'px' })}
            {bottom > 0 && text && borderText({ bottom: '-' + border.bottom + 'px', height: border.bottom + 'px', color: font_color, fontWeight: font_weight, fontSize: font_size + 'px' })}
            {allow_close && <button className="tw-fixed tw-right-3 tw-top-0 tw-flex tw-items-center tw-bg-transparent" style={{ height: border.top + 'px', color: font_color }} onClick={closeClicked}><FontAwesomeIcon icon={faTimes} /></button>}
            {props.children}
            
            <Modal
                icon={<FontAwesomeIcon icon={faPencil} />}
                iconBg="tw-bg-blue-500 tw-text-white"
                contentRaw={
                    <div class="tw-flex tw-flex-col tw-gap-3">
                        <div class="input "><textarea onChange={(ev) => setNewText(ev.target.value)} className="tw-h-24" value={newText}></textarea></div>
                        <div>{t('settings.available-vars')}</div>
                        <div className="tw-flex tw-flex-wrap tw-gap-2">
                            <code className="tw-cursor-pointer" onClick={() => setNewText(newText + ' {user_id}')}>{"{user_id}"}</code>
                            <code className="tw-cursor-pointer" onClick={() => setNewText(newText + ' {username}')}>{"{username}"}</code>
                            <code className="tw-cursor-pointer" onClick={() => setNewText(newText + ' {image_name}')}>{"{image_name}"}</code>
                            <code className="tw-cursor-pointer" onClick={() => setNewText(newText + ' {kasm_id}')}>{"{kasm_id}"}</code>
                            <code className="tw-cursor-pointer" onClick={() => setNewText(newText + ' {image_id}')}>{"{image_id}"}</code>
                            <code className="tw-cursor-pointer" onClick={() => setNewText(newText + ' {egress_provider_name}')}>{"{egress_provider_name}"}</code>
                            <code className="tw-cursor-pointer" onClick={() => setNewText(newText + ' {egress_gateway_name}')}>{"{egress_gateway_name}"}</code>
                            <code className="tw-cursor-pointer" onClick={() => setNewText(newText + ' {egress_gateway_country}')}>{"{egress_gateway_country}"}</code>
                            <code className="tw-cursor-pointer" onClick={() => setNewText(newText + ' {egress_gateway_city}')}>{"{egress_gateway_city}"}</code>
                            <code className="tw-cursor-pointer" onClick={() => setNewText(newText + ' {zone_name}')}>{"{zone_name}"}</code>
                        </div>
                        <button className="tw-bg-transparent tw-mx-3 tw-underline tw-font-bold" onClick={reset}>Reset back</button>
                    </div>
                    
                }
                buttons={
                    <React.Fragment>
                        <button type="button" className="cancelbutton" onClick={() => setOpen(false)}>{t('buttons.Cancel')}</button>
                        <button type="button" className="actionbutton tw-bg-blue-500" onClick={handleSubmit}>{t('buttons.Save')}</button>
                    </React.Fragment>
                }
                open={open}
                setOpen={setOpen}
            />
        </div>
    )
}
